package com.essntl.features.task.data.supabase

import com.essntl.features.itinerary.data.supabase.itinerary.ItineraryDto
import com.essntl.features.itinerary.data.supabase.itinerary_service.ItineraryServiceDto
import com.essntl.features.profile.data.supabase.ProfileDto
import com.essntl.features.proposal.data.supabase.proposal.ProposalDto
import com.essntl.features.task.domain.model.TaskModel
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class TaskDto(
    val id: String,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("updated_at")
    val updatedAt: String?,
    @SerialName("updated_by")
    val updatedBy: String?,
    val notes: String?,
    val title: String?,
    @SerialName("due_date")
    val dueDate: String?,
    @SerialName("itinerary_service_id_data")
    val itineraryService: ItineraryServiceDto?,
    @SerialName("owner_id_data")
    val owner: ProfileDto?,
    @SerialName("itinerary_id_data")
    val itinerary: ItineraryDto?,
    @SerialName("proposal_id_data")
    val proposal: ProposalDto?,
    val status: String?,
) {
    fun toModel() =
        TaskModel(
            id = id,
            createdAt = createdAt,
            updatedAt = updatedAt,
            updatedBy = updatedBy,
            notes = notes,
            title = title,
            dueDate = dueDate,
            itineraryService = itineraryService?.toModel(),
            owner = owner?.toModel(),
            itinerary = itinerary?.toModel(),
            proposal = proposal?.toModel(),
            status =
                when (status) {
                    "TO_DO" -> TaskModel.Status.Todo
                    "DONE" -> TaskModel.Status.Done
                    "BLOCKED" -> TaskModel.Status.Blocked
                    else -> null
                },
        )

    companion object {
        fun getColumns() =
            Columns.raw(
                "*"
                    + ", itinerary_service_id_data:itinerary_service_id(${ItineraryServiceDto.COLUMNS_VALUE})"
                    + ", itinerary_id_data:itinerary_id(${ItineraryDto.COLUMNS_VALUE})"
                    + ", proposal_id_data:proposal_id(${ProposalDto.COLUMNS_VALUE})"
                    + ", owner_id_data:owner_id(*)",
            )
    }
}

internal fun TaskModel.Status.toDto() =
    when (this) {
        TaskModel.Status.Todo -> "TO_DO"
        TaskModel.Status.Done -> "DONE"
        TaskModel.Status.Blocked -> "BLOCKED"
        TaskModel.Status.Archive -> "ARCHIVE"
    }